app.service('productCardPhotos', function(productCardGallery, lazyLoad) {
	var $self, $galleryList, $galleryPointers, $openModalGallery, $images;
	var galleryLength;
	var currentShift = 0;

	function setElements() {
		$self = $('#gallery');
		$galleryList = $('#gallery-list', $self);
		$openModalGallery = $('.js-open-modal-gallery', $self);
		$galleryPointers = $('.js-gallery-pointer', $self);
		$images = $('a', $galleryList);
		galleryLength = $('li', $galleryList).length;
	}
	function setEvents() {
		$galleryList.find('img').each(function() {
			var src = $(this).data('original');
			$(this).attr('src', src);
		});

		$self.swipe({
			swipe: function(
				event,
				direction,
				distance,
				duration,
				fingerCount,
				fingerData
			) {
				switch (direction) {
					case 'left':
						nextPhoto();
						break;
					case 'right':
						previousPhoto();
						break;
				}
			},
			excludedElements: 'button, input, select, textarea, .noSwipe',
			allowPageScroll: 'auto'
		});
		$galleryPointers.on('click', function() {
			setPosition($(this).index());
		});
		$images.on('click', function(event) {
			const type = $(this).data('type');
			productCardGallery.open(currentShift, type);
			event.preventDefault();
		});
		$('.js-show-video-button').on('click', function() {
			UA.pageInteraction('Zdjęcie - wlepka', 'Film promocyjny Euro');
			productCardGallery.open(currentShift, 'video');
		});
	}
	function setPosition(position) {
		if (position > -1 && position < galleryLength) {
			$self.addClass('shift-' + position);
			$self.removeClass('shift-' + currentShift);

			currentShift = position;

			if (currentShift === galleryLength - 1) {
				$self.addClass('shift-last');
			} else {
				$self.removeClass('shift-last');
			}
			lazyLoad.update();
		}
	}
	function nextPhoto() {
		setPosition(currentShift + 1);
	}
	function previousPhoto() {
		setPosition(currentShift - 1);
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init: init
	};
});
